import { Component, OnInit, Input, HostBinding } from '@angular/core';
import * as moment from 'moment';
import { BannerService } from '../../services/student-services/banner/banner.service';
import { PersistentStorageService } from '../../services/common/persistent-storage.service';
import { DataServiceService } from '../../services/student-services/common/data-service.service';
import { CommonService } from '../../services/student-services/common/common.service';
import { LoaderService } from '../../services/common/loader.service';
import { USER_KEY } from '../../constants/user-constants';
import { HeaderService } from '../../services/common/header.service';

@Component({
	selector: 'app-student-home',
	templateUrl: './student-home.component.html',
	styleUrls: [ './student-home.component.scss' ]
})
export class StudentHomeComponent implements OnInit {
	@HostBinding('class') elementClass = 'app-student-home';
	// pass the selected task details to the checklist component.
	@Input() selectedTask;

	// variable declarations
	public showSettings = false;
	public getTokenResult;
	public showOnBoarding = false;
	public currentUser = {};
	public dataLength = 0;
	public startDate_goal;
	public submask_id;
	public showSidebar = false;
	public onboardStudentData;
	public HUD = {
		percentageHUD: 0,
		pacingText: ''
	};

	public studentDetails = {
		studentData: null,
		studentPhases: [],
		phasesData: [],
		taskData: [],
		subTaskData: [],
		goal_data: [],
		subtask_goal: [],
		goal_Date: null
	};
	public studentRecords = {
		phases: []
	};
	public sidebarData;
	public isLoading = true;
	public pageSelector = '';
	public activeView = {
		phase: '',
		task: ''
	};
	public currentPage;

	public phases = [];
	public tasks = [];
	public subtasks = [];
	public viewOnlyData = false;

	constructor(
		private readonly bannerService: BannerService,
		private readonly dataService: DataServiceService,
		private readonly common: CommonService,
		private readonly persistentStorageService: PersistentStorageService,
		private readonly loaderService: LoaderService,
		private readonly headerService: HeaderService
	) {
		this.headerService.hideStaffHeader();
	}

	ngOnInit() {
		sessionStorage.removeItem('updated_at');
		sessionStorage.removeItem('phasesCount');

		/**
     * get logged in user information from firebase auth.
     * @param currentUser user object containing the details of the current user.
     * this will be populated once the user details are obtained from the sirebase auth method.
     */
		const email = this.persistentStorageService.getLocalStorage(USER_KEY.CURRENT_STUDENT_EMAIL);
		if (email) {
			this.currentUser['email'] = email;
			sessionStorage.setItem('email_student', email);
		}
		this.checkifStudentIsExisting(email);
	}

	onStudentSelection(studentEmail) {
		setTimeout(() => this.loaderService.hide(), 3000);
		this.persistentStorageService.setLocalStorage(USER_KEY.CURRENT_STUDENT_EMAIL, studentEmail);
		this.checkifStudentIsExisting(studentEmail);
	}

	// link program code
	public getTemplateFromProgramCode(bannerprogramcode) {
		this.loaderService.show();
		this.dataService.getCollectionDocWithIdByWhere('programs', 'program_code', '==', bannerprogramcode).subscribe(
			(querySnapshotForProgram) => {
				querySnapshotForProgram.forEach((docRef) => {
					if (docRef.id) {
						const contentful_id = docRef.data().contentful_id;
						this.dataService
							.getCollectionDocWithIdByWhere(
								'templates',
								'contentful_program_ids',
								'array-contains',
								contentful_id
							)
							.subscribe(
								(querySnapshotForTemplate) => {
									querySnapshotForTemplate.forEach((docRef) => {
										if (docRef.id) {
											this.createStudent(docRef.id, docRef.data(), this.currentUser);
										}
									});
									this.loaderService.hide();
								},
								(templateErr) => this.loaderService.hide()
							);
					}
				});
			},
			(programErr) => this.loaderService.hide()
		);
	}

	// create student
	public createStudent(templateId, templateData, currentUser) {
		this.generateNewUserTemplate(templateId, templateData, currentUser);
	}

	/**
   * @description Will Creat new user doc for new user
   * @param templateId (string) Template Id
   * @param templateData (Object) Template Object
   * @param currentUser (Object) current logged in user information
   */
	public generateNewUserTemplate(templateId, templateData, currentUser) {
		const student = {};
		const outh_data = {
			l: currentUser.l,
			o: currentUser.o,
			refreshToken: currentUser.refreshToken,
			photoURL: currentUser.photoURL,
			emailVerified: currentUser.emailVerified,
			tenantId: currentUser.tenantId,
			metadata: currentUser.metadata,
			providerData: currentUser.providerData[0]
		};
		student['template_id'] = templateId;
		student['uid'] = currentUser.uid;
		student['upn'] = currentUser.email;
		student['oauth_data'] = JSON.parse(JSON.stringify(outh_data));
		student['banner_data'] = currentUser.banner_data;
		student['display_name'] = currentUser.displayName;
		// get subtasks, total_duration_avg, max, min etc and save to fierstore
		this.getNewUserdefaultData(templateData, student);
	}

	/**
   * @description Will collect and create fileds for new user
   * @param templateData (Object) template data
   * @param student (Object) new student object
   */
	public getNewUserdefaultData(templateData, student) {
		// Collect all the fileld related to that template id
		this.loaderService.show();
		this.dataService
			.getSnapshotOfCollectionDataByWhere('phases', 'contentful_id', 'in', templateData.contentful_phase_ids)
			.subscribe(
				(phases: any) => {
					if (phases) {
						this.dataService.getSnashotOfColecctionData('tasks').subscribe((tasks: any) => {
							if (tasks) {
								this.dataService.getSnashotOfColecctionData('subtasks').subscribe((subtasks: any) => {
									if (subtasks) {
										// reorder all the data
										const allOrderedSubtasks = this.reorderAllPhasesTasksAndSubtasks(
											templateData,
											phases,
											tasks,
											subtasks
										);

										if (allOrderedSubtasks.length > 0) {
											const totalDurationAvg = allOrderedSubtasks.reduce(function(sum, subtask) {
												return sum + parseInt(subtask.time_to_complete_avg);
											}, 0);
											const totalDurationMin = allOrderedSubtasks.reduce(function(sum, subtask) {
												return sum + parseInt(subtask.time_to_complete_min);
											}, 0);
											const totalDurationMax = allOrderedSubtasks.reduce(function(sum, subtask) {
												return sum + parseInt(subtask.time_to_complete_max);
											}, 0);

											student.total_duration_avg = totalDurationAvg;
											student.total_duration_max = totalDurationMax;
											student.total_duration_min = totalDurationMin;

											student.created_at = moment().format();
											student.updated_at = moment().format();
											student.start_date = moment().format();
											student.end_date = moment()
												.add(student.total_duration_avg, 'days')
												.format();
											// get other user key fields
											const overrideAttrs = this.common.overridesFor(
												student,
												allOrderedSubtasks,
												{}
											);
											Object.assign(student, overrideAttrs);
											this.onboardStudentData = student;

											// Save to firestore
											this.generateNewUserData(student);
										}
									} // End of if .. subtasks
								});
							} // End of if ..tasks
						});
					} // End of if..phase
					this.loaderService.hide();
				},
				(error) => this.loaderService.hide()
			);
	}

	/**
   * @description Will reorder all phase, tasks and subtask
   * @param templateData (Object) Template data
   * @param phases (Array) All phases data
   * @param tasks (Array) All tasks data
   * @param subtasks (Array) All subtasks data
   */
	public reorderAllPhasesTasksAndSubtasks(templateData, phases, tasks, subtasks) {
		const allOrderedSubtasks = [];

		for (const templateIndex in templateData.contentful_phase_ids) {
			const phaseId = templateData.contentful_phase_ids[templateIndex];
			phases.find((phase) => {
				if (phase.contentful_id === phaseId) {
					// all_ordered_phases.push(phase);
					// Reorder all Tasks
					for (const phaseIndex in phase.contentful_task_ids) {
						const taskId = phase.contentful_task_ids[phaseIndex];
						tasks.find((task) => {
							if (task.contentful_id === taskId) {
								for (const subtaskIndex in task.contentful_subtask_ids) {
									const subtaskId = task.contentful_subtask_ids[subtaskIndex];
									subtasks.find((subtask) => {
										if (subtask.contentful_id === subtaskId) {
											allOrderedSubtasks.push(subtask);
										}
									}); // end of find
								} // end of for..in subtask
							} // end of if task
						}); // end of ..find task
					} // end of for ..in phase
				} // end of ..if phase
			}); // End of ..find phases
		} // End of for .. in template

		return allOrderedSubtasks;
	}

	/**
   * @description Will simply save the passed object to firestore
   * @param student (Object) New studnt doc object
   */
	public generateNewUserData(student) {
		this.dataService.insertNewStudentData(student).then((result) => {
			this.currentPage = 'onboarding';
		});
	}

	// update existing user
	public updateExistingUser(currentUser, studentData) {
		try {
			this.dataService.updateExistingStudent(currentUser);

			this.loaderService.show();
			this.dataService.getStudentData(currentUser.email).subscribe(
				(data) => {
					if (this.showOnboarding(data)) {
						this.onboardStudentData = data;
						this.currentPage = 'onboarding';
					}
					this.loaderService.hide();
				},
				(error) => this.loaderService.hide()
			);
		} catch (err) {}
	}

	public showOnboarding(sdata) {
		if (sdata.start_date && sdata.end_date && sdata.accepted_terms) {
			return false;
		} else {
			return true;
		}
	}

	public setAllCollectionData(contentful_phase_ids) {
		// Loop through contentful phase ids and get phases by this id
		contentful_phase_ids.forEach((contentful_phase_id, phaseIndex) => {
			this.dataService
				.getCollectionDocWithIdByWhere('phases', 'contentful_id', '==', contentful_phase_id)
				.subscribe(async (phaseDocsRef) => {
					// Storing phases into phases array
					phaseDocsRef.forEach(async (phase) => {
						const phaseData = phase.data();
						phaseData._id = phase.id;
						this.phases.push(phaseData);

						// Storing tasks into tasks array
						phaseData.contentful_task_ids.forEach((contentful_task_id, taskindex) => {
							this.dataService
								.getCollectionDocWithIdByWhere('tasks', 'contentful_id', '==', contentful_task_id)
								.subscribe((taskDocsRef) => {
									taskDocsRef.forEach(async (task) => {
										const taskData = task.data();
										taskData._id = task.id;
										this.tasks.push(taskData);

										// Storing subtasks into subtasks array
										taskData.contentful_subtask_ids.forEach(
											(contentful_subtask_id, subtaskIndex) => {
												this.dataService
													.getCollectionDocWithIdByWhere(
														'subtasks',
														'contentful_id',
														'==',
														contentful_subtask_id
													)
													.subscribe((subtaskDocsRef) => {
														subtaskDocsRef.forEach((subtask) => {
															const subtaskData = subtask.data();
															subtaskData._id = subtask.id;
															this.subtasks.push(subtaskData);
														}); // End of subtask foreach

														if (
															subtaskIndex ===
																taskData.contentful_subtask_ids.length - 1 &&
															phaseIndex === contentful_phase_ids.length - 1 &&
															taskindex === phaseData.contentful_task_ids.length - 1
														) {
															this.getAllCollections();
														}
													}); // End of subtask data service
											}
										); // End of contentful_subtask_ids foreach
									}); // End of tasks foreach
								}); // End of tasks data service
						}); // End of contentful_task_ids foreach
					}); // End of phases foreach
				}); // End of phases data service
		}); // End of contentful_phase_ids foreach
	}

	// get all collections
	public getAllCollections() {
		this.studentRecords['phases'] = [];
		if (this.phases.length > 0) {
			this.studentDetails.phasesData = this.phases;
			this.showSidebar = true;
			if (this.tasks.length > 0) {
				this.studentDetails.taskData = this.tasks;

				if (this.subtasks.length > 0) {
					this.studentDetails.subTaskData = this.subtasks;
					this.studentDetails.studentPhases.forEach((studentPhase) => {
						this.studentDetails.phasesData.forEach((phase) => {
							phase.currentPhase = false;
							if (studentPhase === phase.contentful_id) {
								phase.tasks = phase.tasks ? phase.tasks : [];
								phase.contentful_task_ids.forEach((phaseTask) => {
									this.studentDetails.taskData.forEach((task) => {
										task.currentTask = '';
										if (phaseTask === task.contentful_id) {
											task.subtasks = task.subtasks ? task.subtasks : [];
											task.contentful_subtask_ids.forEach((tasksub) => {
												this.studentDetails.subTaskData.forEach((subtask) => {
													if (tasksub === subtask.contentful_id) {
														let goalDate;
														// Get student data to get the user_subtasks field to calculate the goal and other staffs
														this.dataService
															.getStudentData(this.studentDetails.studentData.upn)
															.subscribe(
																(studentData: any) => {
																	if (studentData) {
																		// Find current subtask
																		const subtaskObject = studentData.user_subtasks.find(
																			(item) => {
																				if (item.subtask_id === subtask._id) {
																					return item;
																				}
																			}
																		);
																		if (subtaskObject.is_complete) {
																			subtask.is_complete = true;
																		} else {
																			subtask.is_complete = false;
																		}
																		goalDate = moment(studentData.start_date)
																			.add(
																				subtaskObject.time_due_from_start,
																				'days'
																			)
																			.format('ll');
																		subtask.goalDate = goalDate;
																		this.studentDetails.studentData = studentData;
																		this.isCheckedSidebarPhaseAndTask();
																	} else {
																		console.error(
																			'UPN mismtached with doc id, No Doc Found'
																		);
																	}
																},
																(err) => {
																	console.error('UPN mismtached with doc id', err);
																}
															);
														task.subtasks.push(subtask);
													}
												});
											});
											phase.tasks.push(task);
										}
									});
								});
								this.studentRecords['phases'].push(phase);
							}
						});
					});
					this.showActivePhaseAndTask(this.studentRecords.phases);
				}
			}
		}
	}

	public showActivePhaseAndTask(data) {
		let currentPhaseFoundFlag;
		let currentTaskFoundFlag;
		const _studentData = this.studentDetails.studentData;
		if (_studentData.current_phase) {
			data.forEach((phase) => {
				if (phase.contentful_id === _studentData.current_phase.contentful_id) {
					phase.currentPhase = true;
					this.activeView.phase = phase.contentful_id;
					currentPhaseFoundFlag = true;
					phase.tasks.forEach((task) => {
						if (task.contentful_id === _studentData.current_task.contentful_id) {
							currentTaskFoundFlag = true;
							this.activeView.task = task.contentful_id;
							this.activeTask(task);
						}
					});
				}
			});

			if (currentPhaseFoundFlag !== true) {
				this.redirectToDefaultTask(data);
			} else {
				if (currentTaskFoundFlag !== true) {
					this.redirectToDefaultTask(data);
				}
			}
		} else {
			this.redirectToDefaultTask(data);
		}
	}

	/**
   * @description If there is any mismatch between current_phase and current_task then redirect to First Pahse and First task
   * @param data (Object) Student data
   */
	private redirectToDefaultTask(data) {
		data[0].currentPhase = true;
		this.activeView.phase = data[0].contentful_id;
		this.activeView.task = data[0].tasks[0].contentful_id;
		this.activeTask(data[0].tasks[0]);
	}

	/**
   * @description EvenEmit This function will redirect the user ro next pending task without refresh
   * @param current_phase_task (Object) Holds next pending task and phase information
   */
	activePhaseAndTaskEvent(current_phase_task) {
		if (current_phase_task.nextPhase && current_phase_task.nextTask) {
			this.activeView.phase = current_phase_task.nextPhase.contentful_id;
			this.activeView.task = current_phase_task.nextTask.contentful_id;
			this.activeTask(current_phase_task.nextTask);
		}
	}

	/**
   * @description check if the student is existing or new student.
   * @param id unique identifier for the student.
   */
	public checkifStudentIsExisting(id) {
		this.loaderService.show();
		this.dataService.getData(id).subscribe(
			(studentDocRef) => {
				const _student = studentDocRef.data();
				if (_student) {
					this.currentUser['displayName'] = _student.display_name;
					if (sessionStorage.getItem('updated_at') !== _student['updated_at']) {
						sessionStorage.setItem('updated_at', _student['updated_at']);
						this.studentDetails.studentData = _student;
						this.getTemplateAndDataForUI(_student['template_id']);
					}
				}
				this.loaderService.hide();
			},
			(error) => this.loaderService.hide()
		);
	}

	/**
   * @description complete the onboarding and goto the checklist page
   * and show the details of the student
   */
	public completeOnBoarding(event) {
		this.currentPage = this.getCurrentPage();
		this.checkifStudentIsExisting(this.currentUser['email']);
	}
	/**
   * @description settingsoutput function to get end date
   * and show the details of the student
   */
	public settingsPageEvent(event) {
		this.studentDetails.studentData.end_date = event;
	}

	/**
   * @description call the banner api and get the student data
   * Note:  On new user login, this data will be used to create the student collection.
   */
	public getBannerData(isNewStudent, studentData) {
		this.bannerService.getAuthTokenForBanner(
			this.bannerService.bannerParams,
			(response) => {
				if (response) {
					sessionStorage.setItem('auth_token', response.access_token);
					this.bannerService.getBannerDetailsfromAPI(
						this.currentUser['email'],
						(response) => {
							if (response) {
								if (response && response[0].ProgramCode) {
									this.currentUser['banner_data'] = response[0];
									if (isNewStudent) {
										// If new student create user for that
										this.getTemplateFromProgramCode(response[0].ProgramCode.split('.')[0]);
									} else {
										// Update the student banner data
										this.updateExistingUser(this.currentUser, studentData);
									}
								}
							}
						},
						(error) => {}
					);
				}
			},
			(error) => {}
		);
	}

	/**
   * @description get template data and then the other details to display in the UI.
   * @param templateId template id of the student which is used to fetch the data
   * from the firestore collection starting with phases.
   */
	public getTemplateAndDataForUI(templateId) {
		this.currentPage = this.getCurrentPage();
		this.loaderService.show();
		this.dataService.getTemplate(templateId).subscribe(
			(templateData: any) => {
				this.studentDetails.studentPhases = templateData.contentful_phase_ids;
				this.tasks = [];
				this.phases = [];
				this.subtasks = [];
				this.setAllCollectionData(templateData.contentful_phase_ids);
				this.loaderService.hide();
			},
			(error) => this.loaderService.hide()
		);
	}

	/**
   * @description display the current subtask in the checklist component.
   * @param task current task whose subtasks are displayed.
   */

	public activeTask(task) {
		this.currentPage = 'student';
		const isTaskLockedInfo = this.checkTaskLockStatus(task._id);
		const taskGoalMessage = this.displayTaskCompleteionInformation(task, isTaskLockedInfo);
		task.isTaskLocked = isTaskLockedInfo ? true : false;
		task.taskGoalMessage = taskGoalMessage;
		this.selectedTask = task;
		this.isLoading = false;
	}

	navigateTo(path: string) {
		this.currentPage = path;
	}

	/**
   * @description This function will add field into studentRecords by which we can show checkbox in sidebar.
   */
	isCheckedSidebarPhaseAndTask() {
		// These are the value to show the check mark
		const completed = 2;
		const ongoing = 1;
		const notYetStarted = 0;
		// Go through each phase and then check each task is completed

		this.studentRecords.phases.forEach((phase, index) => {
			if (phase) {
				// Set default to not yest strated
				this.studentRecords.phases[index].is_complete = notYetStarted;
				let taskIndex = 0;
				let allTaskCompletedCount = 0;
				let alltaskNotyetStartedCount = 0;
				// loop through each task
				while (taskIndex < phase.tasks.length) {
					const task = phase.tasks[taskIndex];
					// check task status
					const isTaskLockedInfo = this.checkTaskLockStatus(task._id);
					if (isTaskLockedInfo) {
						// if completed
						// set flag to completed
						this.studentRecords.phases[index].tasks[taskIndex].is_complete = completed;
						allTaskCompletedCount++;
					} else {
						// If not completed
						// check is there any subtask which is completed
						const completeSubtaskFlag = task.subtasks.find((item) => {
							if (item.is_complete) {
								return item;
							}
						});
						if (completeSubtaskFlag) {
							// If there then set flag accrodig to that
							this.studentRecords.phases[index].tasks[taskIndex].is_complete = ongoing;
						} else {
							// set flag to false either all subtask not complete or not yet started
							this.studentRecords.phases[index].tasks[taskIndex].is_complete = notYetStarted;
							alltaskNotyetStartedCount++;
						}
					}
					taskIndex++;
				} // End of While loop

				if (allTaskCompletedCount === phase.tasks.length) {
					this.studentRecords.phases[index].is_complete = completed;
				} else {
					if (alltaskNotyetStartedCount !== phase.tasks.length) {
						this.studentRecords.phases[index].is_complete = ongoing;
					}
				}
			} // end of if block
		}); // End of foreach
	}

	/**
   * @description This function will return lock status of current selected task
   * @param taskId (string) Seletected task _id
   */
	private checkTaskLockStatus(taskId) {
		const userTasks = this.studentDetails.studentData.user_tasks ? this.studentDetails.studentData.user_tasks : [];
		const taskStatus = userTasks.find((currentObject) => {
			if (currentObject.task_id === taskId) {
				return true;
			}
		});
		if (taskStatus) {
			return taskStatus;
		} else {
			return false;
		}
	}

	/**
   * @description This function will return a message object wich holds the information 
   * regarding task goal information with due text indicator.
   * @param task (Object) Selected task Information
   * @param isTaskLockedInfo (Object) current task lock information status
   */
	private displayTaskCompleteionInformation(task, isTaskLockedInfo) {
		const message = {
			goalDateMessage: '',
			dueSoonText: ''
		};
		const lastSubtask = JSON.parse(JSON.stringify(task.subtasks[task.subtasks.length - 1]));
		if (isTaskLockedInfo) {
			// If task locked then show recent lock activity date
			message.goalDateMessage = 'COMPLETED: ' + moment(isTaskLockedInfo.created_at).format('ll');
		} else {
			if (lastSubtask) {
				const subtaskObject = this.studentDetails.studentData.user_subtasks.find((item) => {
					if (item.subtask_id === lastSubtask._id) {
						return item;
					}
				});
				const now = moment().format('ll');
				const goalDate = moment(this.studentDetails.studentData.start_date).add(
					subtaskObject.time_due_from_start,
					'days'
				);
				message.goalDateMessage = 'GOAL: ' + goalDate.format('ll');
				const future = goalDate.diff(now, 'days');

				if (future < 0) {
					message.dueSoonText = 'Past Goal Date';
				}
				if (future <= 10 && future > 1) {
					message.dueSoonText = future + ' days';
				}

				switch (future) {
					case 0: {
						message.dueSoonText = 'Today';
						break;
					}
					case 1: {
						message.dueSoonText = 'Tomorrow';
						break;
					}
				}
			}
		}
		return message;
	}

	/**
   * @description get the current page for toggling the components.
   * Note: for toggling settings,checklist,faq, resources.
   */
	public getCurrentPage() {
		return location.href.split('#')[1].split('/')[1];
	}

	/**
   * @description Event Emit will send current stauts of HUD [progress bar]
   * @param $event (Object) Student Data
   */
	updateHUD($event) {
		const percentageHUD = this.common.percentComplete($event.user_subtasks);
		const pacingText = this.common.pacingText($event, $event.user_subtasks);
		this.HUD.percentageHUD = percentageHUD;
		this.HUD.pacingText = pacingText;
	}
}
